import http from './http.js'
const project = 'imr-auth/'
const model = 'user'

const account = {
  // 修改密码
  changePwd (data = {}) {
    const url = project + model + '/change'
    return http.post(url, data).then(res => {
      return res
    })
  },

  // 账号登出
  logout () {
    const url = project + model + '/logout'
    return http.get(url).then(res => {
      return res
    })
  },

  // 获取用户信息
  getInfo () {
    const url = project + model + '/getInfo'
    return http.get(url).then(res => {
      return res
    })
  },

  // 自动登陆
  tokenLogin () {
    const url = project + model + '/tokenLogin'
    return http.get(url, {}, false).then(res => {
      return res
    })
  },

  // 重置密码
  resetPassword (data = {}) {
    const url = project + model + '/resetPassword'
    return http.post(url, data).then(res => {
      return res
    })
  },

  // 获取期刊信息
  periodical () {
    const url = project + model + '/periodical'
    return http.get(url).then(res => {
      return res
    })
  },

  // 获取职位信息
  position () {
    const url = project + model + '/position'
    return http.get(url).then(res => {
      return res
    })
  }
}

export default account